import endpoints from '../config/endpoints';

export default async function uploadCustomerCsvAction(token, file) {
	const data = new FormData();
  data.append('csv', file[0])

	return fetch(endpoints.STORE_CUSTOMER_CSV, {
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${token}`,
		},
		body: data
	})
	.then(data => data.json())
	.catch(error => error)
}